<template>
	<div class="zoom">
  		<div class="slide photo1" ref="photo" v-parallax-fit="photo1"></div>
  	</div>
</template>

<script>
export default {
  name: 'slide28',
  data() {
    return {
      photo1: [
        {
          start: 38000,
          end: 38700,
          fromStyle: { transform: 'translateX(0px) translateY(-1250px) rotate(15deg)' },
          toStyle: { transform: 'translateX(-140px) translateY(180px) rotate(-3deg)' }
        },
        {
          start: 39100,
          end: 39600,
          fromStyle: { transform: 'translateX(-140px) translateY(180px) rotate(-3deg)' },
          toStyle: { transform: 'translateX(100px) translateY(1900px) rotate(18deg)' }
        },
      ],
    };
  }
}
</script>

<style lang="scss" scoped>
.photo1 {
    position: fixed;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/28_EastBayTimes.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 730px;
    height: 630px;
    transition: 0.3s;
    transform-origin: center;
    z-index: 5;
    left: calc(50% - 380px);
    top: calc(50% - 471px);
    @media(max-width: 600px) {
      left: calc(50% - 90px);
      top: calc(50% - 271px);
      width: 340px;
      height: 310px;
    }
}
</style>
